/**
 * "Open the draft" (owner, 2026-10-20, after Gyro saved an e-mail draft to his Outlook Drafts: "next time can you also
 * open the draft so i dont have to go search for it?"). The Microsoft 365 connector's create_draft answers with Graph's
 * webLink, the URL that opens that very item in Outlook on the web and in the new Outlook; the Done card offers it as a
 * link, which opens the way every link in a message does (a new tab on the web and in the Office pane; the desktop app
 * hands it to Windows). Only a plain https link to an Outlook host is offered: the result is data the service returned,
 * never a place the model chooses a URL.
 */
export const CREATE_DRAFT_TOOL = 'create_draft';
export const OPEN_DRAFT_LABEL = 'Open the draft';
const OUTLOOK_LINK_HOSTS = new Set(['outlook.office.com', 'outlook.office365.com', 'outlook.cloud.microsoft']);
/** The link a finished action's result carries for the card to open, or undefined when it is not a create_draft result with an Outlook link. */
export function draftOpenLink(tool, result) {
    if (tool !== CREATE_DRAFT_TOOL || !result || typeof result !== 'object' || Array.isArray(result))
        return undefined;
    const { webLink } = result;
    if (typeof webLink !== 'string' || !webLink || webLink.length > 2048)
        return undefined;
    try {
        const url = new URL(webLink);
        return url.protocol === 'https:' && !url.username && !url.password && !url.port && OUTLOOK_LINK_HOSTS.has(url.hostname.toLowerCase()) ? url.href : undefined;
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=draftLink.js.map